<template>
  <span>
    <v-dialog v-model="searchShow" persistent width="500px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" depressed>Search</v-btn>
      </template>
      <v-card>
        <v-card-text>
          <div>
            <p class="title">Appointment Date</p>
            <v-layout row wrap>
              <v-flex xs6 pa-1 class="form-control">
                <v-menu
                  ref="appointmentStart"
                  v-model="showAppointmentStart"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <input
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('Start Date')"
                        readonly
                        :value="formattedAppointmentStart"
                        v-on="on"
                        clearable
                      />
                    </div>
                  </template>
                  <v-date-picker
                    v-model="appointmentStart"
                    no-title
                    @input="showAppointmentStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1 class="form-control">
                <v-menu
                  ref="appointmentEnd"
                  v-model="showAppointmentEnd"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <input
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('End Date')"
                        readonly
                        :value="formattedAppointmentEnd"
                        v-on="on"
                        clearable
                      />
                    </div>
                  </template>
                  <v-date-picker
                    v-model="appointmentEnd"
                    no-title
                    @input="showAppointmentEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <!-- <v-divider></v-divider> -->
            <p class="title">Register Date</p>
            <v-layout row wrap>
              <v-flex xs6 pa-1 class="form-control">
                <v-menu
                  ref="registerStart"
                  v-model="showRegisterStart"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <input
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('Start Date')"
                        readonly
                        :value="formattedRegisterStart"
                        v-on="on"
                        clearable
                      />
                    </div>
                  </template>
                  <v-date-picker
                    v-model="registerStart"
                    no-title
                    @input="showRegisterStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pa-1 class="form-control">
                <v-menu
                  ref="registerEnd"
                  v-model="showRegisterEnd"
                  :close-on-content-click="false"
                  full-width
                  max-width="290px"
                  color="primary"
                >
                  <template v-slot:activator="{ on }">
                    <div>
                      <input
                        type="text"
                        class="form-control browser-default"
                        :placeholder="$t('End Date')"
                        readonly
                        :value="formattedRegisterEnd"
                        v-on="on"
                        clearable
                      />
                    </div>
                  </template>
                  <v-date-picker v-model="registerEnd" no-title @input="showRegisterEnd = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </div>

          <div class="row" style="margin-bottom: 0">
            <div style="text-align: center" class="col s12">
              <v-btn @click="searchShow = false" color="grey" outline>Cancel</v-btn>
              <v-btn @click="onSearch" color="primary" depressed>SEARCH</v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      searchShow: false,
      showAppointmentStart: false,
      showAppointmentEnd: false,
      showRegisterStart: false,
      showRegisterEnd: false,
      appointmentStart: '',
      appointmentEnd: '',
      registerStart: '',
      registerEnd: ''
    }
  },
  computed: {
    formattedAppointmentStart() {
      if (this.appointmentStart) return moment(this.appointmentStart).format('DD-MM-YYYY')
      else return ''
    },
    formattedAppointmentEnd() {
      if (this.appointmentEnd) return moment(this.appointmentEnd).format('DD-MM-YYYY')
      else return ''
    },
    formattedRegisterStart() {
      if (this.registerStart) return moment(this.registerStart).format('DD-MM-YYYY')
      else return ''
    },
    formattedRegisterEnd() {
      if (this.registerEnd) return moment(this.registerEnd).format('DD-MM-YYYY')
      else return ''
    }
  },
  methods: {
    onSearch() {
      var data = {
        appointmentStart: this.appointmentStart,
        appointmentEnd: this.appointmentEnd,
        registerStart: this.registerStart,
        registerEnd: this.registerEnd
      }

      this.$emit('onSearchDate', data)
      this.searchShow = false
    }
  },
  watch: {
    searchShow() {
      this.appointmentStart = ''
      this.appointmentEnd = ''
      this.registerStart = ''
      this.registerEnd = ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/view/template/ananda/SearchDate.vue